module.exports = __webpack_public_path__ + "img/ico_question.d4c4be52.png";